export const missionControl = [
  {
    name: 'Mission Control',
    route: '/home/mission-control',
    permission: 'MissionControl',
  },
  { name: 'Books', route: '/home/books', permission: 'Books' },
  {
    name: 'Bibliographies',
    route: '/home/bibliographies',
    permission: 'Bibliographies',
  },
  // { name: 'Quals', route: '/home/quals', permission: 'Quals' },
  { name: 'Accounts', route: '/home/accounts', permission: 'Accounts' },
  { name: 'Settings', route: '/home/settings', permission: 'Settings' },
  {
    name: 'Practice Exams',
    route: '/home/practice-exams',
    permission: 'PracticeExams',
  },
  { name: 'Search', route: '/home/search', permission: 'Search' },
];

export const accounts = [
  {
    name: 'Students',
    route: '/home/accounts/students',
    permission: 'Accounts.Students',
  },
  {
    name: 'Admins',
    route: '/home/accounts/admins',
    permission: 'Accounts.Admins',
  },
  {
    name: 'Roles',
    route: '/home/accounts/roles',
    permission: 'Accounts.Roles',
  },
  {
    name: 'Teams',
    route: '/home/accounts/teams',
    permission: 'Accounts.Teams',
  },
];

export const missionControlSubHeaderOptions = [
  // {
  //   name: 'Assignments',
  //   route: '/home/mission-control/assignments',
  //   permission: 'MissionControl.Assignments',
  // },
  {
    name: 'Writers',
    route: '/home/mission-control/writers',
    permission: 'MissionControl.Writers',
  },
  {
    name: 'Reports',
    route: '/home/mission-control/reports',
    permission: 'MissionControl.Reports',
  },
  {
    name: 'Message Center',
    route: '/home/mission-control/message-center',
    permission: 'MissionControl.MessageCenter',
  },
  {
    name: 'Customer Submission',
    route: '/home/mission-control/customer-submission',
    permission: 'MissionControl.CustomerSubmission',
  },
];

export const ratingExamsHeaderOptions = [{ name: 'RatingExams', route: ' ' }];

export const quals = [{ name: 'Quals' }];

export const questions = [{ name: 'Question Overview' }];

export const settings = [
  { name: 'Keys', route: '/home/settings/keys', permission: 'Settings.Keys' },
  {
    name: 'Permissions',
    route: '/home/settings/permissions',
    permission: 'Settings.Permissions',
  },
  {
    name: 'AFSCs',
    route: '/home/settings/rates',
    permission: 'Settings.AFSCs',
  },
  {
    name: 'Banners',
    route: '/home/settings/banners',
    permission: 'Settings.Banners',
  },
  {
    name: 'New Coupons',
    route: '/home/settings/newCoupons',
    permission: 'Settings.Coupons',
  },
  {
    name: 'Prompts',
    route: '/home/settings/prompts',
    permission: 'Settings.Prompts',
  },
  {
    name: 'Daily Quiz',
    route: '/home/settings/dailyQuiz',
    permission: 'Settings.DailyQuiz',
  },
  {
    name: 'Audio Generation Queue',
    route: '/home/settings/audioGenerationQueue',
    permission: 'Settings.AudioGenerationQueue',
  },
  {
    name: 'Audio Abbreviations',
    route: '/home/settings/audioAbbreviations',
    permission: 'Settings.AudioAbbreviations',
  },
  {
    name: 'Audio Abbreviations Queue',
    route: '/home/settings/abbreviationsQueue',
    permission: 'Settings.AudioAbbreviationsQueue',
  },
  {
    name: 'Self Promotion',
    route: '/home/settings/selfPromotion',
    permission: 'Settings.SelfPromotion',
  },
];
